module.exports = {"component":"button-stateful","status":"prod","display-name":"Stateful Buttons","classKey":"ButtonStateful","SLDS-component-path":"/components/button/#flavor-stateful","site-stories":[{"heading":"Icon Only","path":"/__examples__/icon.jsx"},{"heading":"Icon and Text","path":"/__examples__/icon-text.jsx"}],"url-slug":"stateful-buttons"}


//////////////////
// WEBPACK FOOTER
// ./~/@salesforce/design-system-react/lib/components/button-stateful/component.json
// module id = 254
// module chunks = 0